module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/meicon-b2c363d9024078bfe9df9e78d373f4e1.svg";